import { render } from "./UomoProfile.vue?vue&type=template&id=43cfb5ae&scoped=true&ts=true"
import script from "./UomoProfile.vue?vue&type=script&lang=ts"
export * from "./UomoProfile.vue?vue&type=script&lang=ts"

import "./UomoProfile.vue?vue&type=style&index=0&id=43cfb5ae&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1364277118/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43cfb5ae"]])

export default __exports__